import { useState } from "react";
import { useCarConfigSelector } from "../redux/store";
import type { ChargingType, PublicChargingType } from "../../../../common-deprecated/types/SettingsType";
import type { ExtraType } from "../../../../common-deprecated/types/CommonTypes";

const useCarConfigPublicChargers = (): PublicChargingType | null => {
    const publicCharging = useCarConfigSelector((state) => state.carConfigSettings.charging)?.find(
        (item) => item.type === "public",
    );
    // Casted purely because lint flips out even though infered type is correct
    return (publicCharging as PublicChargingType) || null;
};

type CarConfigChargerTabsReturnType = {
    aceData: ChargingType[] | null;
    homechargers: ExtraType[];
    activeTab: ChargingType | null;
    setActiveTab: (tab: ChargingType) => void;
};

export const useCarConfigChargerTabs = (): CarConfigChargerTabsReturnType => {
    const homechargers = useCarConfigSelector((state) =>
        state.items.extras.filter((charger) => charger.isCharger && !charger.isHidden),
    );
    const aceData = useCarConfigSelector((state) =>
        state.carConfigSettings.charging && state.carConfigSettings.charging.length > 0
            ? state.carConfigSettings.charging
            : null,
    );
    const [activeTab, setActiveTab] = useState<ChargingType | null>(aceData?.[0] || null);

    return { aceData, homechargers, activeTab, setActiveTab };
};

export default useCarConfigPublicChargers;
